

export const INDICATOR_RECEIVER_ORG_REQUEST = "INDICATOR_RECEIVER_ORG_REQUEST";
export const INDICATOR_RECEIVER_ORG_SUCCESS = "INDICATOR_RECEIVER_ORG_SUCCESS";
export const INDICATOR_RECEIVER_ORG_FAIL = "INDICATOR_RECEIVER_ORG_FAIL"
